export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LcrfLotAAAAAKzZQDeBApUOAOW0iPm7bW_zhTLp',
  },

   // baseUrl: 'https://localhost:7249/api/'
  // baseUrl: 'https://turkeydirect-dev.azurewebsites.net/api/'
  baseUrl: 'https://www.turkeylitigation.com/api/'

};

